const carousels = document.querySelectorAll('.carousel');

Array.from(carousels).forEach((carousel) => {
  const slidesBox = carousel.querySelector('.slides');
  const originalSlides = [...slidesBox.querySelectorAll('.card')];
  // const viewportMiddle = carousel.getBoundingClientRect().width / 2;
  const indicators = carousel.querySelectorAll('.indicator');
  const arrowsDiv = carousel.querySelector('.arrow-wrapper');
  const arrowLeft = carousel.querySelector('.slider-arrow-prev');
  const arrowRight = carousel.querySelector('.slider-arrow-next');
  let carouselBreakpoint = 0;
  let clones = [];
  let itemsAndClones = [];
  let expanded = 1;

  const originalSlidesWidth = () => {
    originalSlides.forEach((slide) => {
      carouselBreakpoint += slide.offsetWidth;
    });

    return carouselBreakpoint;
  };

  /**
   *
   * Observes carousel at the start
   */
  const carouselStartCallback = (entry) => {
    const firstCard = entry[0];

    if (firstCard.isIntersecting && firstCard.intersectionRatio === 1) {
      // when you scroll to the start
      if (clones.length) {
        slidesBox.scrollLeft = clones[0].offsetLeft - 50;
      }
    }
  };

  const carouselStart = new IntersectionObserver(carouselStartCallback, {
    root: slidesBox,
    rootMargin: '0px',
    threshold: 1,
  });

  /**
   *
   * Observes carousel at the end
   */
  const carouselEndCallback = (entry) => {
    const lastIndex = originalSlides.length - 1;
    const lastCard = entry[0];

    if (lastCard.isIntersecting && lastCard.intersectionRatio === 1) {
      // when you scroll to the end
      slidesBox.scrollLeft =
        originalSlides[lastIndex].offsetLeft -
        (carousel.offsetWidth - originalSlides[lastIndex].offsetWidth) -
        50;
    }
  };

  const carouselEnd = new IntersectionObserver(carouselEndCallback, {
    root: slidesBox,
    rootMargin: '0px',
    threshold: 1,
  });

  /**
   *
   * Observes carousel - Mobile
   */
  const carouselCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const newActive = Number(entry.target.dataset.slide);

        // Mobile
        // removes all active indicators
        for (let k = 0; k < indicators.length; k++) {
          indicators[k].classList.remove('active');
        }
        // adds active indicator
        indicators[newActive - 1].classList.add('active');
      }
    });
  };

  const observer = new IntersectionObserver(carouselCallback, {
    root: slidesBox,
    rootMargin: '0px',
    threshold: 0.5,
  });
  originalSlides.forEach((slide) => {
    observer.observe(slide);
  });

  /**
   *
   * Activates new card (slides it over and toggles visibility)
   */
  const activatesCard = (clickedNum) => {
    if (expanded !== clickedNum) {
      // scrolls card to new active position
      const cardWidth = originalSlides[clickedNum - 1].offsetWidth;
      slidesBox.scrollLeft = (clickedNum - 1) * cardWidth - 50;

      // toggles open/close
      const activeSlides = [
        ...document.querySelectorAll(`[data-slide*="${expanded}"]`),
      ];
      const newActiveSlides = [
        ...document.querySelectorAll(`[data-slide*="${clickedNum}"]`),
      ];

      // closes previously active
      activeSlides.forEach((slide) => {
        slide.classList.remove('open');
      });
      // opens new active
      newActiveSlides.forEach((slide) => {
        slide.classList.add('open');
      });

      expanded = clickedNum;
    }
  };

  /**
   * Sets Click Events for Arrows and Mobile Indicators
   */
  if (indicators) {
    indicators.forEach((indicator) => {
      indicator.addEventListener('click', () => {
        const clicked = Number(indicator.dataset.slide);
        const cardWidth =
          originalSlides[clicked - 1].getBoundingClientRect().width;
        // scroll to new position
        slidesBox.scroll({
          top: 0,
          left: (clicked - 1) * cardWidth,
          behavior: 'smooth',
        });
      });
    });

    // Reset to first indicator on resize
    let timeout = false;
    const resetCards = () => {
      if (!indicators[0].classList.contains('active')) {
        indicators[0].click();
      }
    };
    window.addEventListener('resize', () => {
      clearTimeout(timeout);
      timeout = setTimeout(resetCards, 250);
    });
  }
  if (arrowLeft) {
    // Scroll Left
    arrowLeft.addEventListener('click', () => {
      const previousCardNum =
        expanded === 1 ? originalSlides.length : expanded - 1;
      activatesCard(previousCardNum);
    });
  }
  if (arrowRight) {
    // Scroll Right
    arrowRight.addEventListener('click', () => {
      const nextCardNum = expanded === originalSlides.length ? 1 : expanded + 1;
      activatesCard(nextCardNum);
    });
  }

  /**
   * Sets/Removes Click Events for Every Card
   */
  const addClickEvents = (slides) => {
    slides.forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.href) {
          return true;
        }

        if (window.innerWidth < 768) {
          return true;
        }

        const clickedNum = Number(card.dataset.slide);
        activatesCard(clickedNum);
      });
    });
  };
  const removeClickEvents = (slides) => {
    slides.forEach((card) => {
      card.removeEventListener('click', (e) => {});
    });
  };

  /**
   * Activates carousel edge observing on desktop
   * if client width is smaller than slider
   */
  const carouselLoads = () => {
    if (window.innerWidth >= 768) {
      // if slidesBox fits in container, run edge observers
      if (carouselBreakpoint > carousel.clientWidth) {
        // creates clones
        if (!clones.length) {
          originalSlides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.classList.add('clone');
            slidesBox.appendChild(clone);
            clones.push(clone);
          });

          // array of both original and cloned
          itemsAndClones = [...slidesBox.querySelectorAll('.card')];

          addClickEvents(itemsAndClones);
        }

        // runs observers
        carouselStart.observe(itemsAndClones[0]);
        carouselEnd.observe(itemsAndClones[itemsAndClones.length - 1]);
        slidesBox.classList.remove('justify-center');

        // shows arrows
        if (arrowsDiv) {
          arrowsDiv.classList.remove('hidden');
        }
      } else {
        // removes all clones
        if (clones.length) {
          clones.forEach(() => {
            slidesBox.removeChild(slidesBox.lastElementChild);
          });

          removeClickEvents(itemsAndClones);

          clones = [];
          itemsAndClones = [];
        }

        addClickEvents(originalSlides);
        slidesBox.classList.add('justify-center');

        // hides arrows
        if (arrowsDiv) {
          arrowsDiv.classList.add('hidden');
        }
      }
    }
  };

  /**
   *
   * Initiates carousel and recalculates positions on window resize
   */
  window.addEventListener('resize', () => {
    carouselLoads();
  });

  carouselBreakpoint = originalSlidesWidth();
  carouselLoads();

  /**
   *
   * Optional - removes manual slide effect
   */
  // slidesBox.addEventListener('wheel', (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   return false;
  // });
});
